module.exports = __webpack_public_path__ + "static/media/hero-960.55ddedcd.jpg";